// ===== TRUST BADGE ENHANCEMENT — PlaygroundTilesUK =====
(function() {
  var CSS = '.pm-trust-badges{display:flex!important;flex-wrap:wrap!important;gap:10px!important;margin:16px 0!important}' +
    '.pm-trust-badge{display:inline-flex!important;align-items:center!important;gap:6px!important;' +
    'padding:10px 16px!important;border-radius:8px!important;font-size:14px!important;' +
    'font-weight:700!important;border-width:2px!important;border-style:solid!important;' +
    'letter-spacing:.01em!important;min-height:40px!important}';

  function injectBadgeCSS() {
    var existing = document.getElementById('pm-badge-override');
    if (existing) { existing.textContent = CSS; return; }
    var s = document.createElement('style');
    s.id = 'pm-badge-override';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // Run multiple times to beat app injection timing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadgeCSS);
  } else {
    injectBadgeCSS();
  }
  window.addEventListener('load', injectBadgeCSS);
  setTimeout(injectBadgeCSS, 500);
  setTimeout(injectBadgeCSS, 1500);
  setTimeout(injectBadgeCSS, 3000);
})();
// ===== END TRUST BADGE ENHANCEMENT =====
